import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useTranslation } from "react-i18next";
import Card from "../../../components/Cards/Card";
import { Add } from "../../../components/Icons/Icons";
import { ModalCreateGroup } from "../../../components/ClinicalTrials/Regulatory/ModalCreateGroup";
import { Spinner } from "../../../components/Utils/Loaders";
import { getRegulatoryGroups, deleteRegulatoryGroup } from "../../../api/clinicalTrial";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";

export const RegulatoryGroups = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const loadData = async () => {
    const result = await getRegulatoryGroups();

    if (result.status === 200) {
      setGroups(result.data);
    }
  };

  useEffect(() => {
    if (!!groups) {
      return;
    }

    loadData();
  }, []);

  const [groups, setGroups] = useState();

  const columns = [
    { dataField: "name", text: t("regulatorySubmissions.groups.groupName") },
    {
      dataField: "attachmentsCategories",
      text: t("regulatorySubmissions.groups.categories"),
      formatter: (cell) => {
        const names = cell.map((ac) => ac.name).join(", ");
        return names;
      },
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "",
      formatter: (_, row) => (
        <span
          style={{ cursor: "pointer", color: "#dc3545", fontSize: "16px" }}
          onClick={() => handleDeleteGroup(row)}
          title={t("regulatorySubmissions.groups.deleteGroupTooltip")}
        >
          <i className="fa fa-trash" />
        </span>
      ),
      headerStyle: { width: "50px", textAlign: "center" },
      align: "center",
    },
  ];

  const handleDeleteGroup = async (group) => {
    if (!group?.id) return;
    try {
      const result = await deleteRegulatoryGroup(group.id);
      if (result.status === 200) {
        setGroups((prev) => prev.filter((g) => g.id !== group.id));
      }
    } catch (error) {
      HandleApiError(error);
    }
  };

  return (
    <>
      <Card
        content={
          <Row>
            <Col md={12}>
              {!groups && <Spinner />}
              {groups && (
                <>
                  <div style={{ marginTop: "20px" }}>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setShowModal(true)}
                    >
                      <Add /> {t("regulatorySubmissions.groups.addGroupLabel")}
                    </button>
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <BootstrapTable
                      keyField="id"
                      data={groups}
                      columns={columns}
                      bordered={false}
                      classes="table-spaced table-spaced-small"
                      wrapperClasses="table-responsive"
                      noDataIndication={() => (
                        <>
                          {t(
                            "regulatorySubmissions.groups.noGroupsTableMessage"
                          )}
                        </>
                      )}
                    />
                  </div>
                </>
              )}
            </Col>
          </Row>
        }
      />

      {showModal && (
        <ModalCreateGroup
          show={showModal}
          onClose={() => setShowModal(false)}
          onAccept={() => {
            setShowModal(false);
            loadData();
          }}
        />
      )}
    </>
  );
};
